import { render, staticRenderFns } from "./Accounttab.vue?vue&type=template&id=4fb2fb98"
import script from "./Accounttab.vue?vue&type=script&lang=js"
export * from "./Accounttab.vue?vue&type=script&lang=js"
import style0 from "./Accounttab.vue?vue&type=style&index=0&id=4fb2fb98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports